const assert = (type) => {
  return (val)=>{
    return typeof val === type;
  };
};

const assertFunction = assert('function');
const assertNumber = assert('number');

const isDOM = typeof HTMLElement === 'object' ? (dom) => {
  return dom instanceof HTMLElement;
} : (dom) => {
  return dom && typeof dom === 'object' && dom.nodeType === 1 && typeof 	dom.nodeName === 'string';
};

const compose = (...funcs) => {
  if (funcs.length === 0) {
    return arg => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
};
const deepClone = (obj) =>{
  return JSON.parse(JSON.stringify(obj));
};

function throttle(fn, delay = 500) {
  let timer = null;
  return function() {
    if (timer) return;
    timer = setTimeout(() => {
      fn.apply(this, arguments);
      timer = null;
    }, delay);
  };
}

export {
  assertFunction,
  assertNumber,
  deepClone,
  isDOM,
  compose,
  throttle
};
